import { Toolbar } from "primereact/toolbar";
import { IPermissionProps } from "../../models/Login";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import React, { useEffect, useRef, useState } from "react";
import { Button } from "primereact/button";
import { IModal } from "./POIncDistribution";
import { Fetch } from "../../shared/Fetch";
import { EmptyIncDist } from "./EmptyIncDist";

export interface IPoIncDistribution {
    id?: number;
    role_ID?: number,
    inc_Per?: number,
    created_On?: Date,
    created_By?: number,
    updated_By?: number,
    updated_On?: Date,


};

interface Iprops {
    setModal: (modal: IModal) => void,
    toast: any,
    reload: boolean,
    permissions: IPermissionProps,
    setReload: (is: boolean) => void,
}



export const Table = (props: Iprops) => {

    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: Array<IPoIncDistribution>, loading: boolean });
    const dt = useRef<any>(null);

    const leftToolbarTemplate = () => {
        return (

            <React.Fragment>
                <div className="my-2">
                    <Button label="New" icon="pi pi-plus" className="p-button-success mr-2" onClick={openNew} />
                </div>
            </React.Fragment>
        );
    };

    const header = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
            <h5 className="m-0">PO Incentive Distribution</h5>
        </div>
    );

    const openNew = () => {
        props.setModal({ open: true, singleData: EmptyIncDist });
    };
    const openEdit = (rowData: IPoIncDistribution) => {
        props.setModal({ open: true, singleData: rowData });
    };
    const action = (rowData: IPoIncDistribution) => {
        return (
            <div className="flex gap-3">
                <Button className="pi pi-pencil text-primary bg-white border-none" onClick={() => openEdit(rowData)}></Button>
            </div>
        );
    }

    const loadTableData = async () => {
        setTableData({ tableData: tableData.tableData, loading: true });
        const response = await Fetch("PO_Incentive_Distribution", "GET", null, null, props.toast);
        if (response) {
            const data = await response.json();
            setTableData({ tableData: data, loading: false });
        }
    }

    useEffect(() => {
        loadTableData();
    }, [props.reload]);

    return (
        <>
            <Toolbar className="mb-1 py-0" left={leftToolbarTemplate}></Toolbar>
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }}
                ref={dt} size="small" stripedRows scrollable scrollHeight="75vh"
                value={tableData.tableData}
                resizableColumns showGridlines columnResizeMode="expand"
                emptyMessage="No Requirements found."
                header={header}
                loading={tableData.loading}
            >
                <Column header="SN." body={(data, options) => options.rowIndex + 1} />
                <Column field="inc_Per" header="Inc Per(%)" />
                <Column field="role_Name" header="Role Name" />
                <Column field="created_By_Name" header="Created By" />
                <Column field="updated_By_Name" header="Updated By" />

                <Column field="created_On" header="Created On" body={(rowData: any) => <p>{`${new Date(rowData?.created_On || "").toDateString()}`}</p>} />
                <Column field="updated_On" header="Updated On" body={(rowData: any) => rowData?.updated_On ? <p>{`${new Date(rowData?.updated_On || "").toDateString()}`}</p> : ""} />

                {/* <Column field="inc_Per" header="Inc Per(%)"/> */}

                <Column field="" header="Action" body={action} />
            </DataTable>
        </>
    );
}